import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import overviewImage from "../assets/images/staticOverviewImage.avif"; // Replace with your static image
import { FaBinoculars, FaRegLightbulb } from "react-icons/fa"; // Importing Icons

const Overview = () => {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className="bg-gray-100 py-12 px-6 md:px-16"
    >
      {/* Content Section */}
      <div className="flex flex-col md:flex-row items-center gap-12">
        {/* Left Column - About Us Section */}
        <motion.div
          className="flex-1 text-center md:text-left"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-red-600 mb-6">
            About Us
          </h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            Discover excellence at Joy Gardens School, where holistic education and personal development meet. Joy Gardens focuses on providing a strong educational foundation, enhanced through modern teaching methodologies and Christian values.
          </p>

          <div className="space-y-8">
            {/* Vision */}
            <div className="flex items-center gap-4">
              <div className="text-blue-600 text-4xl">
                <FaBinoculars />
              </div>
              <div>
                <h4 className="text-xl font-bold text-blue-900">Vision</h4>
                <p className="text-gray-700">
                  To be a regional model in providing holistic learning experiences that inspire and empower learners for future success.
                </p>
              </div>
            </div>

            {/* Mission */}
            <div className="flex items-center gap-4">
              <div className="text-green-600 text-4xl">
                <FaRegLightbulb />
              </div>
              <div>
                <h4 className="text-xl font-bold text-blue-900">Mission</h4>
                <p className="text-gray-700">
                  Our mission is to inspire greatness and Godliness in our learners.
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Right Column - Static Image */}
        <motion.div
          className="flex-1"
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <img
            src={overviewImage}
            alt="Overview"
            className="rounded-lg shadow-lg w-full h-auto object-cover"
          />
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Overview;
